/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * Global Data Bus for all modules to get wine club offer data and
 * state
 */
export class WineClubOffersBusInput implements Msdyn365.IActionInput {
    public getCacheKey = () => `WineClubOffer`;
    public getCacheObjectType = () => 'WineClubOffer';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

export interface IWineClubOffersBusData {
    offerTaken: boolean;
    wineClubId: string;
    offerAcceptedText: Msdyn365.RichText;
    offerIdUsed: string;
}

const createInput = (): Msdyn365.IActionInput => {
    return new WineClubOffersBusInput();
};

async function action(input: WineClubOffersBusInput, ctx: Msdyn365.IActionContext): Promise<IWineClubOffersBusData> {
    return { offerTaken: false, wineClubId: '', offerAcceptedText: 'TESTING', offerIdUsed: '' };
}

export const IWineClubOffersBusAction = Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IWineClubOffersBusData>>action,
    input: createInput
});

export default IWineClubOffersBusAction;
